import * as React from 'react'
import clsx from 'clsx'
import * as plume from '@ulule/owl-kit-components/next'

import { Container } from '../../_shared/Container'
import { SectionHead, SectionHeadHighlight } from '../../_shared/SectionHead'
import { STATUS } from '../content'
import { FIGURES } from '../figures'
import { useStatsTracking } from '../tracking'
import styles from './Status.module.css'

const SLICE_TONES = [styles.sliceOne, styles.sliceTwo, styles.sliceThree]

/**
 * `figures.json` is hand-edited and nothing caps `ownerTypes` at three, so the tones cycle rather
 * than running off the end — a fourth slice would otherwise render with no background at all,
 * invisible on the cream band, and with a colourless legend swatch.
 */
function sliceTone(index: number): string {
  return SLICE_TONES[index % SLICE_TONES.length] as string
}

export function Status(): React.ReactElement {
  const tracking = useStatsTracking()
  const slices = FIGURES.ownerTypes

  return (
    <section className={styles.status}>
      <Container>
        <SectionHead
          size="wide"
          kicker={STATUS.kicker}
          title={
            <>
              {'Qui sont les '}
              <SectionHeadHighlight>porteurs</SectionHeadHighlight>
              {' et les '}
              <SectionHeadHighlight>porteuses</SectionHeadHighlight>
              {' de projets ?'}
            </>
          }
          lede={STATUS.lede}
        />
        {/* One bar, three flex-weighted segments — the weights are the percentages themselves. */}
        <div className={styles.split}>
          {slices.map((slice, index) => (
            <div key={slice.label} className={clsx(styles.sg, sliceTone(index))} style={{ flex: slice.percent }}>
              {slice.percent}%
            </div>
          ))}
        </div>
        <div className={styles.legend}>
          {slices.map((slice, index) => (
            <div key={slice.label} className={styles.lg}>
              <span className={clsx(styles.lg__sw, sliceTone(index))} aria-hidden="true" />
              <span>
                <strong>{slice.label}</strong>
                <span>{slice.percent}&nbsp;% des collectes</span>
              </span>
            </div>
          ))}
        </div>
        <p className={styles.pull}>
          {STATUS.womenLedClaim}
          <em>{STATUS.womenLedEmphasis}</em>.
        </p>
        <div className={styles.status__cta}>
          <plume.RoundButton
            as="a"
            href={STATUS.cta.href}
            color="black"
            size="big"
            onClick={() => tracking.ctaClick('status')}
          >
            {STATUS.cta.label}
          </plume.RoundButton>
        </div>
      </Container>
    </section>
  )
}
